/* !
 * setting.js v1.0.0
 * Copyright, Connecty Inc.
 */
(() => {
	const siteName = 'default-package';
	const htmlHasClass = (_class) => { return document.documentElement.classList.contains(_class); };
	const a = 'is-active';
	const v = 'is-visible';

	FUNCTIONS = {
		va: {
			pathname: location.pathname,
			isEnglish: (location.pathname.indexOf('/english/') === 0) ? true : false,
			isMobile: htmlHasClass('ua-mobile'),
			device: {
				desktop: 1025,
				sp: 768
			},
			window: {
				width: window.innerWidth,
				height: window.innerHeight
			},
			header: {
				desktop: 100,
				sp: 53
			},
			newsFileType: [
				'.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx', '.csv', '.tsv', '.txt', '.rtf', '.png', '.jpg', '.jpeg', '.gif', '.webp', '.svg', '.bmp', '.tif', '.tiff',
				'.zip', '.7z', '.rar', '.tar', '.gz', '.bz2', '.mp3', '.wav', '.m4a', '.aac', '.flac', '.mp4', '.mov', '.m4v', '.avi', '.wmv', '.webm'
			],
		},
		localDecision() {
			const regExp = new RegExp(`(test\\.${siteName}\\.connecty\\.co\\.jp|copre\\.jp|localhost|192\\.168\\.)`, 'g');
			return regExp.test(location.hostname);
		},
		localLoading() { // ローカル環境ならincludeをAjaxで読み込む
			const _this = this;
			const key = 'inc_';
			let ajaxArray = [];
			let ajaxArrayList = [];
			let includeClass = document.querySelectorAll(`[class*="${key}"]`);

			includeClass.forEach(ele => {
				let path = ele.innerHTML.split(' ')[1];
				ajaxArray.push(path);
			});

			if (ajaxArray.length) {
				ajaxArray.forEach(ele => {
					let xhr = new XMLHttpRequest();
					let promise = new Promise((resolve, reject) => {
						xhr.onreadystatechange = function () {
							if (xhr.readyState === 4) {
								if (xhr.status === 200) {
									resolve(xhr.responseText);
								} else {
									reject(xhr.statusText);
								}
							}
						};
					});
					xhr.open('GET', ele + '.html', true);
					xhr.send();
					ajaxArrayList.push(promise);
				});

				Promise.all(ajaxArrayList).then(results => {
					let regExp = new RegExp(key);

					results.forEach(ele => {
						let classList = ele.split(/ |\"/g);
						let position;

						classList.forEach(ele2 => {
							if (ele2.match(regExp)) { position = ele2; }
						});
						document.querySelectorAll('.' + position).forEach(ele2 => {
							ele2.outerHTML = ele;
						});
						console.log('Succeeded to read the include file!:', position);
					});

					// 置換完了時にカスタムイベントを発火
					document.dispatchEvent(new Event('localincludeLoaded'));

					_this.loadDelayScript();
				}).catch((error) => {
					console.error('Failed to read the include file:', error);

					document.dispatchEvent(new Event('localincludeLoaded'));
					_this.loadDelayScript();
				});
			} else {
				document.dispatchEvent(new Event('localincludeLoaded'));
				_this.loadDelayScript();
			}
		},
		getQuery() {
			let vars = [];
			let hash = null;
			let hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
			hashes.forEach(ele => {
				hash = ele.split('=');
				hash[1] = (hash[1].indexOf('#') !== -1) ? hash[1].split('#')[0] : hash[1];
				vars.push(hash[0]);
				vars[hash[0]] = hash[1];
			});
			return vars;
		},
		removeElmIfEmpty() {
			// ＜ルート設定対応＞要素が空だったら削除
			const $eleList = document.querySelectorAll('.js-checkEmptyElm');
			$eleList.forEach(ele => {
				if (!ele.textContent.length) {
					ele.remove();
				}
			});
		},
		removeBlockIfListEmpty () {
			// ＜ルート設定対応＞該当のリストにルート設定出力が0件の場合、指定する親ブロックごと削除する
			const $eleList = document.querySelectorAll('.js-checkEmptyList');
			if ($eleList) {
				$eleList.forEach(ele => {
					if (!ele.getElementsByTagName('li').length) {
						ele.closest('.js-checkEmptyList-wrap').remove();
					}
				});
			}
		},
		accordion() {
			const details = document.querySelectorAll('.js-accordion');

			details.forEach(ele => {
				const summary = ele.querySelector('summary');
				const wrapper = ele.querySelector('.mod-accordion-wrapper');
				const plus = ele.querySelector('.mod-accordion-plus');
				summary.addEventListener('click', e => {
					e.preventDefault();
					if (ele.open) {
						ele.classList.remove('is-visible');
						const close = wrapper.animate(
							{
								opacity: [1, 0],
								height: [wrapper.offsetHeight + 'px', 0],
							},
							{
								duration: 300,
								easing: 'ease',
							}
						);
						if (plus) {
							plus.animate(
								{ rotate: ['90deg', '0deg'] },
								{
									duration: 300,
									pseudoElement: "::after",
									easing: 'ease',
									fill: 'forwards',
								}
							);
						}
						close.onfinish = () => {
							ele.removeAttribute('open');
						}
					} else {
						ele.setAttribute('open', 'true');
						ele.classList.add('is-visible');
						wrapper.animate(
							{
								opacity: [0, 1],
								height: [0, wrapper.offsetHeight + 'px'],
							},
							{
								duration: 300,
								easing: 'ease',
							}
						);
						if (plus) {
							plus.animate(
								{ rotate: ['0deg', '90deg'] },
								{
									duration: 300,
									pseudoElement: "::after",
									easing: 'ease',
									fill: 'forwards',
								}
							);
						}
					}
				});
			});
		},
		pulldown() {
			const setPulldown = (_e, _ele, _summary, _content, _h) => {
				const option = { duration: 300, easing: 'ease', fill: 'forwards' };
				const option_content = { duration: 300, easing: 'ease' };
				const arrow = _summary.querySelector('svg');

				if (_e) { _e.preventDefault(); }

				if (_ele.open) {
					const close = _content.animate({
						opacity: [1, 0],
						height: [_content.offsetHeight + 'px', 0],
					}, option_content);

					_ele.animate({ height: [(_summary.offsetHeight + _content.offsetHeight + 3) + 'px', _h] }, option);
					arrow.animate([
						{ transform: 'rotateX(180deg)' },
						{ transform: 'rotateX(0deg)' }
					], option);

					close.onfinish = () => {
						_ele.removeAttribute('open');
					}
				} else {
					_ele.setAttribute('open', 'true');
					_ele.animate({ height: [_h, (_summary.offsetHeight + _content.offsetHeight + 3) + 'px'] }, option);
					arrow.animate([
						{ transform: 'rotateX(0deg)' },
						{ transform: 'rotateX(180deg)' }
					], option);

					_content.animate({
						opacity: [0, 1],
						height: [0, _content.offsetHeight + 'px'],
					}, option_content);
				}
			};
			const details = document.querySelectorAll('.mod-pulldown > details:not(#irp-library-quarter-category-year-selector)');
			details.forEach(ele => {
				const summary = ele.querySelector('summary');
				const content = ele.querySelector('.mod-pulldown-content');
				let h = ele.offsetHeight + 'px';
				summary.addEventListener('click', e => {
					setPulldown(e, ele, summary, content, h);
				});
			});
			document.addEventListener('click', e => {
				if (!e.target.closest('.mod-pulldown')) {
					details.forEach(ele => {
						if (ele.open) {
							setPulldown(false, ele, ele.querySelector('summary'), ele.querySelector('.mod-pulldown-content'), ele.closest('.mod-pulldown').offsetHeight + 'px')
						}
					});
				}
			});
		},
		tabSwitch() {
			let $tab = document.querySelectorAll('.js-tab');
			let $content = document.querySelectorAll('.js-tab-content');
			if ($tab.length) {
				$tab.forEach(ele => {
					ele.addEventListener('click', () => {
						$tab.forEach(ele2 => { ele2.classList.remove(a); })
						ele.classList.add(a);
						$content.forEach(ele => {
							ele.classList.remove(a);
							ele.classList.remove(v);
						});

						let $target;
						let target = ele.getAttribute('data-target');
						$target = document.querySelectorAll('[data-target="' + target + '"]');
						$target.forEach(ele => {
							ele.classList.add(a);
							setTimeout(() => { ele.classList.add(v); }, 200);
						});
					});
				});
			}
		},
		easeScroll() {
			const scrollToObject = (_self) => {
				let hash = _self.currentTarget.href.split('#')[1];
				let pos = hash === 'pagetop' ? 0 : document.getElementById(hash).getBoundingClientRect().top;
				let offset = hash === 'pagetop' ? 0 : window.scrollY;
				pos += offset;

				if (hash !== 'pagetop') {
					if (FUNCTIONS.va.window.width < FUNCTIONS.va.device.desktop) {
						pos = (FUNCTIONS.va.pathname.indexOf('/history/') !== -1) ?
							pos - FUNCTIONS.va.header.sp - document.querySelector('.js-tab-content.is-active .corp-history-anchor').offsetHeight : pos - FUNCTIONS.va.header.sp;
					} else {
						pos = (FUNCTIONS.va.pathname.indexOf('/history/') !== -1) ?
							pos - FUNCTIONS.va.header.desktop - document.querySelector('.js-tab-content.is-active .corp-history-anchor').offsetHeight : pos - FUNCTIONS.va.header.desktop;
					}
				}
				window.scrollTo({ top: pos, behavior: 'smooth' });
			}
			// フォーカス用関数
			const scrollFocus = (_hash) => {
				let hash = _hash;
				if (hash !== 'pagetop') {
					const focusableElementsSelector = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, [tabindex="0"], [contenteditable]';
					const focusableElements = Array.from(
						document.getElementById(hash).querySelectorAll(focusableElementsSelector)
					);
					if(focusableElements.length) {
						focusableElements[0].focus({ preventScroll: true });
					}
				}
			};
			// スクロール完了後に実行する関数
			let scrollResolveTimeout;
			const waitForScrollComplete = (_hash) => {
			  return new Promise((resolve) => {
				const scrollTimeout = setTimeout(() => {
				  resolve(true);
				}, 100);
				const scrollTimeoutEvent = addEventListener('scroll', function fn (e) {
					clearTimeout(scrollTimeout);
					clearTimeout(scrollResolveTimeout);
					scrollResolveTimeout = setTimeout(function () {
						scrollFocus(_hash);
						removeEventListener('scroll', fn);
						resolve(true);
					}, 100);
				});
			  });
			};
			document.querySelectorAll('a[rel="scroll"]').forEach((ele) => {
				ele.addEventListener('click', async (e) => {
					e.preventDefault();
					if (/#/.test(e.currentTarget.href)) {
						scrollToObject(e);
						let hash = e.currentTarget.href.split('#')[1];
						await waitForScrollComplete(hash);
						return false;
					}
				});
			});
		},
		headerMenu() {
			const f = 'is-fixed';
			const o = 'is-open';
			let $header = document.querySelector('.header');
			let $headerNav = document.querySelector('.header-nav');
			let $headerMegaSwitch = document.querySelectorAll('.header-nav .js-megaMenuOpen');
			let $hamburger = document.querySelector('.header-hamburger');
			let $headerSubMenu = document.querySelectorAll('.js-headerSubMenu');
			let $search = document.querySelector('.header-search');
			let $searchBtn = document.querySelectorAll('.js-header-search');
			let $overlay = document.querySelector('.header-overlay');
			let $container = document.querySelector('.container');

			// スクロール時class
			const hiddenHeaderOnScroll = () => {
				let options = {
					root: null,
					rootMargin: `100px 0px ${document.body.clientHeight}px 0px`,
					threshold: 1
				};

				document.body.classList.add('is-top');

				const callback = (entries, observer) => {
					entries.forEach(entry => {
						if (entry.isIntersecting) {
							document.body.classList.add('is-top');
						} else {
							document.body.classList.remove('is-top');
						}
					});
				};
				let observer = new IntersectionObserver(callback, options);
				observer.observe(document.body);
			};
			hiddenHeaderOnScroll();

			// メガメニュー開閉
			const megaMenu = () => {
				$headerMegaSwitch.forEach((ele) => {
					ele.addEventListener('click', () => {
						if (ele.classList.contains(o)) {
							// Close
							ele.classList.remove(o);

							if (FUNCTIONS.va.window.width > FUNCTIONS.va.device.desktop) {
								ele.nextElementSibling.classList.remove(v);
								setTimeout(() => { ele.nextElementSibling.classList.remove(a); }, 400);
								$header.classList.remove(o);
								$overlay.classList.remove(v);
								setTimeout(() => { $overlay.classList.remove(a); }, 400);
							} else {
								ele.nextElementSibling.style.height = null;
							}
						} else {
							// Open
							if (FUNCTIONS.va.window.width > FUNCTIONS.va.device.desktop) {
								// 他のメニューを閉じる
								$headerMegaSwitch.forEach((ele2) => {
									if (ele2.nextElementSibling.classList.contains(a)) {
										ele2.classList.remove(o);
										ele2.nextElementSibling.classList.remove(v);
										setTimeout(() => { ele2.nextElementSibling.classList.remove(a); }, 400);
									}
								});
								// サイト内検索閉じる
								// if ($search.classList.contains(a)) {
								// 	$search.classList.remove(v);
								// 	setTimeout(() => { $search.classList.remove(a); }, 400);
								// }
								// オーバーレイが無ければ出す
								if (!$overlay.classList.contains(a)) {
									$overlay.classList.add(a);
									setTimeout(() => { $overlay.classList.add(v); }, 100);
								}
							}

							$header.classList.add(o);
							ele.classList.add(o);
							ele.nextElementSibling.classList.add(a);
							if (FUNCTIONS.va.window.width > FUNCTIONS.va.device.desktop) {
								setTimeout(() => { ele.nextElementSibling.classList.add(v); }, 100);
							} else {
								ele.nextElementSibling.style.height = ele.nextElementSibling.scrollHeight + 'px';
							}
						}
					});
				});
			};
			megaMenu();

			// [PC] サイト内検索開閉
			const setSiteSearch = () => {
				$searchBtn.forEach((ele) => {
					ele.addEventListener('click', () => {
						if ($search.classList.contains(a)) {
							// Close
							$search.classList.remove(v);
							setTimeout(() => { $search.classList.remove(a); }, 400);
							$header.classList.remove(o);
							$overlay.classList.remove(v);
							setTimeout(() => { $overlay.classList.remove(a); }, 400);
						} else {
							// Open
							// 他のメニューを閉じる
							$headerMegaSwitch.forEach((ele2) => {
								if (ele2.nextElementSibling.classList.contains(a)) {
									ele2.classList.remove(o);
									ele2.nextElementSibling.classList.remove(v);
									setTimeout(() => { ele2.nextElementSibling.classList.remove(a); }, 400);
								}
							});
							if (!$overlay.classList.contains(a)) {
								$overlay.classList.add(a);
								setTimeout(() => { $overlay.classList.add(v); }, 100);
							}

							$header.classList.add(o);
							$search.classList.add(a);
							setTimeout(() => { $search.classList.add(v); }, 100);
						}
					});
				});
			}
			setSiteSearch();

			// [SP] ハンバーガーメニュー
			const setHamburger = () => {
				$hamburger.addEventListener('click', (e) => {
					if ($hamburger.classList.contains(a)) {
						// Close
						$headerNav.classList.remove(v);
						$overlay.classList.remove(v);
						setTimeout(() => {
							$headerNav.classList.remove(a);
							$overlay.classList.remove(a);
						}, 400);
						$hamburger.classList.remove(a);
						$header.classList.remove(o);
						$overlay.classList.remove(v);
						setTimeout(() => { $overlay.classList.remove(a); }, 400);
					} else {
						// サイト内検索閉じる
						if ($search.classList.contains(a)) {
								$search.classList.remove(v);
								setTimeout(() => { $search.classList.remove(a); }, 400);
							}
						// オーバーレイが無ければ出す
						if (!$overlay.classList.contains(a)) {
							$overlay.classList.add(a);
							setTimeout(() => { $overlay.classList.add(v); }, 100);
						}

						$header.classList.add(o);
						$hamburger.classList.add(a);
						$headerNav.classList.add(a);
						setTimeout(() => { $headerNav.classList.add(v); }, 100);
					}
				});
			};
			setHamburger();

			// [SP] サブメニュー開閉
			const spSubMenu = () => {
				$headerSubMenu.forEach((ele) => {
					ele.addEventListener('click', (e) => {
						e.preventDefault();
						if (ele.classList.contains(a)) {
							ele.classList.remove(a);
							ele.nextElementSibling.classList.remove(a);
							ele.nextElementSibling.style.height = null;
							ele.closest('.__megaMenu').style.height = (ele.closest('.__megaMenu').scrollHeight - ele.nextElementSibling.scrollHeight) + 'px';
						} else {
							ele.classList.add(a);
							ele.nextElementSibling.classList.add(a);
							ele.nextElementSibling.style.height = ele.nextElementSibling.scrollHeight + 'px';
							ele.closest('.__megaMenu').style.height = (ele.closest('.__megaMenu').scrollHeight + ele.nextElementSibling.scrollHeight) + 'px';
						}
					});
				});
			};
			if (FUNCTIONS.va.window.width < FUNCTIONS.va.device.desktop) {
				spSubMenu();
			}

			// [PC] オーバーレイエリア押下でメガメニューを閉じる
			const closeOverlay = () => {
				$overlay.addEventListener('click', () => {
					$headerMegaSwitch.forEach((ele) => {
						if (ele.classList.contains(o)) {
							ele.classList.remove(o);
							ele.nextElementSibling.classList.remove(v);
							setTimeout(() => { ele.nextElementSibling.classList.remove(a); }, 400);
						}
					});
					// サイト内検索閉じる
					if ($search.classList.contains(a)) {
						$search.classList.remove(v);
						setTimeout(() => { $search.classList.remove(a); }, 400);
					}
					$header.classList.remove(o);
					$overlay.classList.remove(v);
					setTimeout(() => { $overlay.classList.remove(a); }, 400);
				});
			};
			closeOverlay();

			// [PC] ESCキー押下でメガメニューを閉じる
			const closeESCKey = () => {
				document.addEventListener('keydown', (e) => {
					if (e.key === 'Escape') {
						if ($overlay.classList.contains(a)) {
							$headerMegaSwitch.forEach((ele) => {
								if (ele.nextElementSibling.classList.contains(a)) {
									ele.classList.remove(o);
									ele.nextElementSibling.classList.remove(v);
									setTimeout(() => { ele.nextElementSibling.classList.remove(a); }, 400);
								}
							});
							$header.classList.remove(o);
							$overlay.classList.remove(v);
							setTimeout(() => { $overlay.classList.remove(a); }, 400);
							fixedOffContainer();
						}
					}
				});
			};
			closeESCKey();

			// カレント処理
			let map = FUNCTIONS.va.isEnglish ? FUNCTIONS.va.pathname.split('/')[2] : FUNCTIONS.va.pathname.split('/')[1];
			switch (map) {
				case 'product': document.querySelector('.js-megaMenuOpen[data-category="product"]').classList.add('is-current'); break;
				case 'rd': document.querySelector('.js-megaMenuOpen[data-category="rd"]').classList.add('is-current'); break;
				case 'sustainability': document.querySelector('.js-megaMenuOpen[data-category="sustainability"]').classList.add('is-current'); break;
				case 'ir': document.querySelector('.js-megaMenuOpen[data-category="ir"]').classList.add('is-current'); break;
				case 'corporate':
					if (FUNCTIONS.va.pathname.indexOf('about-us') !== -1) {
						document.querySelector('.__head[data-category="aboutus"]').classList.add('is-current'); break;
					} else {
						document.querySelector('.js-megaMenuOpen[data-category="corporate"]').classList.add('is-current'); break;
					}
				case 'news': document.querySelector('.__head[data-category="news"]').classList.add('is-current'); break;
				case 'recruit': document.querySelector('.js-megaMenuOpen[data-category="recruit"]').classList.add('is-current'); break;
				default: break;
			}
		},
		footerMenu() {
			// カレント処理
			let map = FUNCTIONS.va.isEnglish ? FUNCTIONS.va.pathname.split('/')[2] : FUNCTIONS.va.pathname.split('/')[1];
			switch (map) {
				case 'product': document.querySelector('.footer-nav-menu [data-category="product"]').classList.add('is-current'); break;
				case 'rd': document.querySelector('.footer-nav-menu [data-category="rd"]').classList.add('is-current'); break;
				case 'sustainability': document.querySelector('.footer-nav-menu [data-category="sustainability"]').classList.add('is-current'); break;
				case 'ir': document.querySelector('.footer-nav-menu [data-category="ir"]').classList.add('is-current'); break;
				case 'corporate': document.querySelector('.footer-nav-menu [data-category="corporate"]').classList.add('is-current'); break;
				case 'news': document.querySelector('.footer-nav-menu [data-category="news"]').classList.add('is-current'); break;
				case 'topics': document.querySelector('.footer-nav-menu [data-category="topics"]').classList.add('is-current'); break;
				case 'recruit': document.querySelector('.footer-nav-menu [data-category="recruit"]').classList.add('is-current'); break;
				default: break;
			}
		},
		pageTop() {
			let footer = document.querySelector('.footer');
			let $pagetop = document.querySelector('.footer-pagetop');

			if ($pagetop) {
				window.addEventListener('scroll', (e) => {
					if (window.scrollY > '100') {
						$pagetop.classList.add(v);
					} else {
						$pagetop.classList.remove(v);
					}
				});
			}
		},
		setModal() {
			const createModal = (_appendHTML,_target) => {
				const $container = document.createElement('div');
				$container.className = 'mod-modal-overlay';
				$container.innerHTML = _appendHTML;
				document.body.appendChild($container);

				$container.classList.add(a);
				setTimeout(() => {
					$container.classList.add(v);
					document.querySelectorAll('.mod-modal-closeArea, .mod-modal-closeBtn, .mod-modalContent a').forEach((ele) => {
						ele.addEventListener('click', (e) => {
							$container.classList.remove(v);
							setTimeout(() => {
								$container.classList.remove(a);
								$container.remove();
								_target.focus();
							}, 400);
						});
					});
					window.addEventListener("keydown", function (event) {
						if(document.querySelectorAll('.mod-modal-overlay').length) {
							// タブキーが押された時
							if (event.key === "Tab") {
								event.preventDefault();
								// モーダル要素内のフォーカス可能な要素の一覧を取得
								const focusableElementsSelector = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, [tabindex="0"], [contenteditable]';
								const focusableElements = Array.from(
								document.querySelector('.mod-modal-overlay').querySelectorAll(focusableElementsSelector)
								);
								// 現在のフォーカス位置を取得
								const focusedItemIndex = focusableElements.indexOf(document.activeElement);
								// shiftキーと同時に押されてた場合
								if (event.shiftKey) {
								if (focusedItemIndex === 0) {
									// 現在のフォーカスが最初の要素の場合、最後の要素にフォーカスを移動
									focusableElements[focusableElements.length - 1].focus();
								} else {
									// 現在のフォーカスが最初の要素以外の場合、前の要素にフォーカスを移動
									focusableElements[focusedItemIndex - 1].focus();
								}
								} else {
								if (focusedItemIndex === focusableElements.length - 1) {
									// 現在のフォーカスが最後の要素の場合、最初の要素にフォーカスを移動
									focusableElements[0].focus();
								} else {
									// 現在のフォーカスが最後の要素以外の場合、次の要素にフォーカスを移動
									focusableElements[focusedItemIndex + 1].focus();
								}
								}
							}
							// ESCキーが押された時
							if (event.key === "Escape") {
								event.preventDefault();
								$container.classList.remove(v);
								setTimeout(() => {
									$container.classList.remove(a);
									$container.remove();
									_target.focus();
								}, 400);
							}
						}
					});
				});
			};
			document.querySelectorAll('.mod-modal').forEach((ele) => {
				ele.addEventListener('click', (e) => {
					let targetKey = e.currentTarget.getAttribute('data-target');
					let $content = document.querySelector(`.mod-modalContent[data-target="${targetKey}"]`);
					if ($content) {
						let closeButton = document.createElement('button');
						closeButton.setAttribute('type', 'button');
						closeButton.className = 'mod-modal-closeBtn';
						closeButton.setAttribute('aria-label', 'close');
						closeButton.innerHTML = '<span aria-hidden="true"></span>';

						$content.appendChild(closeButton);

						let closeArea = document.createElement('div');
						closeArea.className = 'mod-modal-closeArea';
						let containerDiv = document.createElement('div');
						containerDiv.appendChild(closeArea);
						containerDiv.appendChild($content.cloneNode(true));

						createModal(containerDiv.innerHTML, e.currentTarget);
					}
					return false;
				});
			});

			// 画像1個だけのモーダル
			document.querySelectorAll('.mod-modalImg').forEach((ele) => {
				ele.addEventListener('click', (e) => {
					let appendHTML = `<div class="mod-modal-closeArea"></div>
						<button type="button" class="mod-modal-closeBtn" aria-label="close"><span aria-hidden="true"></span></button>
						${e.currentTarget.querySelector('img').outerHTML}`;
					createModal(appendHTML,e.currentTarget);
					return false;
				});
			});
		},
		modalVideo() {
			const modalVideo = document.querySelectorAll('.js-modal-video').length;
			if (modalVideo) {
				new ModalVideo('.js-modal-video', {
					channel: 'youtube',
					autoplay: 1,
				});
			}
		},
		matchHeight(_ele) {
			const $elements = (_ele) ? _ele : document.querySelectorAll('[data-mh]');
			const groups = new Map();

			$elements.forEach( ele => { ele.style.height = 'auto'; } ); // 初期化

			$elements.forEach( ele => {
				const attributeName = ele.getAttribute('data-mh');
				if ( !groups.has( attributeName ) ) {
					groups.set( attributeName, [] );
				}
				groups.get( attributeName ).push( ele );
			} );
			groups.forEach( group => {
				const attributeGroups = new Map();
				group.forEach( ele => {
					const attributeName = ele.getAttribute('data-mh');
					const topPosition = ele.getBoundingClientRect().top;
					const key = attributeName + '_' + topPosition;
					if ( !attributeGroups.has( key ) ) {
						attributeGroups.set( key, [] );
					}
					attributeGroups.get( key ).push( ele );
				} );
				attributeGroups.forEach( (item) => {
					const maxHeight = Math.max( ...item.map( ele => ele.offsetHeight ) );
					item.forEach( (ele2) => {
						ele2.style.height = `${maxHeight}px`;
					});
				});
			} );
		},
		scrollableTable() {
			document.querySelectorAll('.js-scrollable').forEach(ele => {
				let chip = ele.querySelector('.mod-scroll-swipe');
				ele.querySelector('.mod-scroll').addEventListener('scroll', () => {
					chip.remove();
				});
			});
		},
		fileSize() {
			const bytesToSize = (bytes) => {
				var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
				if (bytes === 0) {
					return 'n/a';
				}
				var i = Math.floor(Math.log(bytes) / Math.log(1024));
				if (i === 0) {
					return bytes + ' ' + sizes[i];
				}
				const value = bytes / Math.pow(1024, i);
				return parseFloat(value.toFixed(1)) + ' ' + sizes[i];
			}
			if (document.querySelectorAll('.js-fileSize').length) {
				document.querySelectorAll('.js-fileSize').forEach(function (pdfElement) {
					pdfElement.textContent = bytesToSize(pdfElement.textContent);
				});
			}
		},
		setShareLinks() {
			document.querySelectorAll('.mod-share a').forEach(ele => {
				let url = encodeURIComponent(document.URL);
				let title = encodeURIComponent(document.title);
				ele.setAttribute('href', ele.getAttribute('href').replace(/#url/ig, url).replace(/#text/ig, title));
			});
		},
		openAboutDKS() {
			document.querySelectorAll('.js-openAboutDKS').forEach(ele => {
				ele.addEventListener('click', () => {
					window.open('/corporate/about_dks/', '', 'width=1100,height=620');
				});
			});
		},
		prodSearchKeyword() {
			const buildQuery = (_input) => {
				// 半角・全角スペースで分割
				const words = _input
					.trim()
					.split(/[\s　]+/)
					.filter(Boolean)
					.slice(0, 5); // 5つまで

				return words
					.map((w, i) => `p_keywords_${i + 1}=${encodeURIComponent(w.normalize('NFKC'))}`)
					.join("&");
			}
			document.querySelectorAll('.js-prodSearchKeyword').forEach(ele => {
				const input = ele.previousElementSibling;
				ele.addEventListener('click', () => {
					const query = buildQuery(input.value);
					location.href = ele.closest('form').getAttribute('action') + '?' + query;
				});
				input.addEventListener('keydown', (e) => {
					if (e.key === 'Enter') {
						e.preventDefault();
						const query = buildQuery(input.value);
						location.href = ele.closest('form').getAttribute('action') + '?' + query;
					}
				});
			});
		},

		loadDelayScript() {
			let _this = this;
			_this.removeElmIfEmpty();
			_this.removeBlockIfListEmpty();
			_this.accordion();
			_this.pulldown();
			_this.tabSwitch();
			// _this.easeScroll();
			if (document.querySelector('.header')) { _this.headerMenu(); }
			if (document.querySelector('.footer')) { _this.footerMenu(); }
			_this.pageTop();
			_this.setModal();
			_this.modalVideo();
			_this.matchHeight();
			_this.scrollableTable();
			_this.fileSize();
			_this.setShareLinks();
			_this.openAboutDKS();
			_this.prodSearchKeyword();

			let resizeTime = 0;
			window.addEventListener('resize', () => {
				clearTimeout(resizeTime);
				resizeTime = setTimeout(() => { _this.matchHeight(); }, 300);
			});
		}
	};

	document.addEventListener('DOMContentLoaded', () => FUNCTIONS.localDecision() ? FUNCTIONS.localLoading() : FUNCTIONS.loadDelayScript());
})();
